import { makeAutoObservable } from "mobx";

import type { CurrencyCode } from "@mr-portfolio-models/currency";

export class SettingsStore {
  public displayCurrency: CurrencyCode = "EUR";

  public constructor() {
    makeAutoObservable(this);
  }

  public setDisplayCurrency(currency: CurrencyCode): void {
    this.displayCurrency = currency;
  }
}
